/*
 * @Author: zhangyugegeliuchen@didichuxing.com 
 * @Date: 2018-12-05 18:16:03
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2022-04-19 16:15:42
 * @Description:  收入组件 展示用户已提现收入和未提现收入
 */
<template>
  <div :class="{'xtd-common-income-container': !isIPad, 'iPad-xtd-common-income-container': isIPad}" @click.stop="jumpToReward">
    <div class="title" v-if="showTitle && item.rate !== 1">
      {{gettext('我的奖励')}}
      <i class="icon-arrow"></i>
    </div>
    <div class="content">
      <div class="item">
        <p class="money" v-html="rewardedTemp"></p>
        <span class="status">{{gettext('已获得奖励')}}</span>
      </div>
      <div class="line no-px2rem"></div>
      <div class="item">
        <p class="money" v-html="pendingTemp"></p>
        <span class="status">
          {{gettext('待入账奖励')}}
          <i v-if="!showTitle" class="icon-i" @click="$refs.tip.show()" style="position:relative">
            <rich-tip 
              ref="tip" 
              direction="top" 
              effect="dark" 
              :animation="false"
              :offsetRight="20"
            >
              <div class="tipText">{{ $t('FoodD_Activity_Rewards_will_TMCp'/* 奖励将在活动结束后计入 */) }}</div>
            </rich-tip>
          </i>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import currentTrans from '@/common/js/currency-config'
import { getAmountTmpl } from '@/common/js/utils'
export default {
  name: 'commonIncome',
  props: {
    preview:Boolean,
    showTitle: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object,
      default: {
        rate: 1,
        currency: '$',
        settlement: '100',
        settlement_highlight_display: {
          'symbol': '$',
          'number': '100',
          'position': 0,
          'display': '$ 100',
          'sign': '-'
        },
        unSettlement: '200',
        unSettlement_highlight_display: {
          'symbol': '$',
          'number': '200',
          'position': 0,
          'display': '$ 200',
          'sign': '-'
        }
      }
    }
  },
  computed: {
    rewardedTemp () {
      if (this.item.rewarded_highlight_display) {
        const splitData = {
          split: this.numfilter(this.item.rewarded_highlight_display),
          symbolClass: 'symbol',
          numberClass: 'amount'
        }
        return getAmountTmpl(splitData)
      }
      return ''
    },
    pendingTemp () {
      if (this.item.pending_highlight_display) {
        const splitData = {
          split: this.numfilter(this.item.pending_highlight_display),
          symbolClass: 'symbol',
          numberClass: 'amount'
        }
        return getAmountTmpl(splitData)
      }
      return ''
    }
  },
  methods: {
    jumpToReward () {
      if(this.preview) return
      if (this.showTitle && this.item.rate !== 1) {
        this.$router.push({
          path: `/d/rewardlist`
          // path: `/d/rewardlist?cityID=${this.item.cityID}&cityName=${this.item.cityName}`
        })
      }
    },
    getCurrency (current) {
      return (currentTrans[current] || currentTrans['']).symbol
    },
    getMoney (current, money, item) {
      if (!money) return 0
      let res = currentTrans[current] || currentTrans['']
      return parseInt(money / res.rate)
    },
    numfilter (amountSplit) {
      return {
        'symbol': amountSplit.symbol,
        'number': String(amountSplit.number).split('.')[0],
        'position': amountSplit.position,
        'display': amountSplit.display,
        'sign': amountSplit.sign
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/base"
@import "~@/common/stylus/mixin"
$conversion = 0.5859375px
.xtd-common-income-container {
  box-sizing: border-box;
  height: 285px;
  width: auto;
  background: #fff;
  padding: 56px 0;
  .no-px2rem {
    width: auto;
    padding: 0;
    border-1px(rgba(0,0,0,0.08), 4px, solid)
    top: 3px;
  }
  .no-px2rem:after {
    height: 96px;
    border-width: 1px;
  }
  .title {
    margin-bottom: -34px
    display: flex
    justify-content: space-between
    align-items: center
    padding: 0 40px
    font-family: 'Aspira Demi'
    color: #000
    font-size: 40px
    text-align: left
    font-weight: 600
    .icon-arrow {
      width: 32px
      height: 32px
      background: url("../../../assets/images/xtd/icon_arrow.png") no-repeat
      background-size: 100% 100%
      color:#666
      font-size: 24px
      margin-left: 8px
    }
  }
  .content {
    display: flex
    padding-top: 88px
    justify-content: space-between
    .rich-tip {
      right: -50px
      top: 50px
      width: 396px
      text-align: left
      .tipText {
        width: 396px
        font-style: normal
      }
    }
    .item {
      flex: 1
      text-align: center
      .money {
        display: flex
        justify-content: center
        font-family: 'Aspira Demi'
        font-size: 48px
        font-weight: 500
      }
      .status {
        display: flex
        justify-content: center
        align-items: center
        font-family: 'Aspira Regular'
        font-weight: 400
        font-size: 24px
        line-height: 32px
        margin-top: 16px
        color: #999
        .icon-i {
          display: inline-block
          margin-left: 10px
          width: 32px
          height: 32px
          background: url("../../../assets/images/xtd/icon_i.png") no-repeat
          background-size: 100% 100%
        }
      }
    }
    .item /deep/ .symbol {
      display: inline-block
      vertical-align: middle
     }
    .item /deep/ .amount {
      display: inline-block
      margin-left: 6px
      font-style: normal
      vertical-align: bottom
    }
  }
}
.iPad-xtd-common-income-container {
  width: 510*$conversion
  background: #F7F8FA;
  padding: 20*$conversion 0
  margin-top: 70*$conversion
  .no-px2rem {
    border-1px(rgba(0,0,0,0.08), 4px, solid)
  }
  .title {
    font-size: 22*$conversion
    color: #4A4A4A
    text-align: center
    .icon-arrow {
      color:#999999
      font-size: 22*$conversion
      margin-left: 8*$conversion
    }
  }
  .content {
    display: flex
    margin-top: 28*$conversion
    justify-content: space-between
    .item {
      flex: 1
      text-align: center
      .money {
        display: flex;
        justify-content: center;
      }
      .status {
        color: #999
        display: block
        font-size: 18*$conversion
        margin-top: 4*$conversion
      }
    }
    .item /deep/ .symbol {
      display: inline-block
      color: #333
      font-size: 32*$conversion
      vertical-align: middle;
    }
    .item /deep/ .amount {
      display: inline-block
      color: #333
      font-size: 32*$conversion
      font-style: normal
      line-height: 32*$conversion
      vertical-align: bottom
    }
  }
}
</style>
